module.exports = __webpack_public_path__ + "img/banner-2.066d514.svg";